// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ou-0";
export var leftAlign = "_ou-4";
export var listItem = "_ou-2";
export var listItemWrapper = "_ou-1";
export var operationText = "_ou-3";